export default "__VITE_ASSET__Dc6EP5I8__"